import React from 'react';
import clsx from 'clsx';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './UnderlineTabs.module.scss';

export interface UnderlineTab {
    id: string;
    label: string;
    icon?: IconDefinition;
}

interface UnderlineTabsProps {
    tabs: Array<UnderlineTab>;
    selectedId: string;
    onSelect: (id: string) => void;
    className?: string;
}

export const UnderlineTabs: React.FC<UnderlineTabsProps> = ({ tabs, selectedId, onSelect, className }) => (
    <div
        role="tablist"
        className={clsx(styles.root, className)}
    >
        {tabs.map(tab => (
            <button
                key={tab.id}
                type="button"
                role="tab"
                aria-selected={tab.id === selectedId}
                className={clsx(styles.tab, { [styles.selected]: tab.id === selectedId })}
                onClick={() => onSelect(tab.id)}
            >
                {tab.icon && <FontAwesomeIcon icon={tab.icon} />}
                {tab.label}
            </button>
        ))}
    </div>
);

export default UnderlineTabs;
